import { render, staticRenderFns } from "./EditTemplates.tmplacements.vue?vue&type=template&id=eb98b9b8&scoped=true&lang=html&"
import script from "./EditTemplates.tmplacements.vue?vue&type=script&lang=js&"
export * from "./EditTemplates.tmplacements.vue?vue&type=script&lang=js&"
import style0 from "./EditTemplates.tmplacements.vue?vue&type=style&index=0&id=eb98b9b8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb98b9b8",
  null
  
)

export default component.exports